
      import Alpine from 'alpinejs';
      import { settings, auth, getAuthHeaders } from '/src/services/api.js';
      import { session } from '/src/services/auth.js';

      document.addEventListener('alpine:init', () => {
        Alpine.data('settingsPage', () => ({
          opensubtitles: {
            apiKey: '',
            primaryLanguage: 'en',
            secondaryLanguage: '',
            configured: false,
            saving: false,
            success: '',
            error: '',
          },
          preferences: {
            adultContentEnabled: false,
            success: '',
            error: '',
          },

          async init() {
            // Check authentication
            const { authenticated } = await session.checkAuth();
            if (!authenticated) {
              window.location.href = '/login.html';
              return;
            }

            // Load existing configurations
            await this.loadSettings();
          },

          async loadSettings() {
            try {
              // Load preferences
              const prefs = await settings.getPreferences();
              this.preferences.adultContentEnabled = prefs.adult_content_enabled;

              // Load OpenSubtitles configuration
              const osConfig = await settings.getOpenSubtitles();
              this.opensubtitles.configured = osConfig.configured;
              if (osConfig.configured) {
                this.opensubtitles.primaryLanguage = osConfig.primary_language || 'en';
                this.opensubtitles.secondaryLanguage = osConfig.secondary_language || '';
              }
            } catch (error) {
              console.error('Failed to load settings:', error);
            }
          },

          async saveOpenSubtitles() {
            this.opensubtitles.saving = true;
            this.opensubtitles.success = '';
            this.opensubtitles.error = '';

            try {
              await settings.saveOpenSubtitles(
                this.opensubtitles.apiKey,
                this.opensubtitles.primaryLanguage,
                this.opensubtitles.secondaryLanguage || null
              );
              this.opensubtitles.success = 'OpenSubtitles configuration saved!';
              this.opensubtitles.configured = true;
              this.opensubtitles.apiKey = ''; // Clear for security
              setTimeout(() => {
                this.opensubtitles.success = '';
              }, 3000);
            } catch (error) {
              this.opensubtitles.error = error.message || 'Failed to save';
            } finally {
              this.opensubtitles.saving = false;
            }
          },

          async removeOpenSubtitles() {
            this.opensubtitles.success = '';
            this.opensubtitles.error = '';

            try {
              await settings.removeOpenSubtitles();
              this.opensubtitles.configured = false;
              this.opensubtitles.apiKey = '';
              this.opensubtitles.primaryLanguage = 'en';
              this.opensubtitles.secondaryLanguage = '';
              this.opensubtitles.success = 'OpenSubtitles configuration removed!';
              setTimeout(() => {
                this.opensubtitles.success = '';
              }, 3000);
            } catch (error) {
              this.opensubtitles.error = error.message || 'Failed to remove';
            }
          },

          async savePreferences() {
            this.preferences.success = '';
            this.preferences.error = '';

            try {
              await settings.updatePreferences(this.preferences.adultContentEnabled);
              this.preferences.success = 'Preferences updated!';
              setTimeout(() => {
                this.preferences.success = '';
              }, 3000);
            } catch (error) {
              this.preferences.error = error.message || 'Failed to update';
            }
          },
        }));
      });

      window.Alpine = Alpine;
      Alpine.start();
    